// Firebase import
import { db } from "../../constants/Firebase";
import {
  collection,
  addDoc,
  doc,
  getDoc,
  setDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";

const dbTable = collection(db, "users");

interface UserSignUpModel {
  firstName: string;
  lastName: string;
  email: string;
}

interface UserModel {
  firstName: string;
  lastName: string;
  year: string;
  major: string;
  email: string;
  amSessions: string[];
  pmSessions: string[];
  googleId: string;
}

const getRandomInt = (max: number) => {
  return Math.floor(Math.random() * max);
};

const colors: string[] = [
  "Red",
  "Orange",
  "Yellow",
  "Green",
  "Blue",
  "Indigo",
  "Violet",
  "Grey",
];

const animals: string[] = [
  "Toad",
  "Bear",
  "Tiger",
  "Lion",
  "Giraffe",
  "Frog",
  "Whale",
  "Dog",
  "Cat",
  "Hippo",
  "Rhino",
  "Chicken",
  "Cow",
];

const generatePassword = () => {
  const colorIdx = getRandomInt(8);
  const animalIdx = getRandomInt(13);
  const idx = getRandomInt(10);
  return `${colors[colorIdx]}${animals[animalIdx]}${idx}`;
};

const validateEmail = (email: string) => {
  return email.match(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
};

const checkWhiteList = async (email: string): Promise<string> => {
  // if (validateEmail(email)) {
  const ref = doc(db, "whitelistedUsers", email);
  const docSnap = await getDoc(ref);
  if (docSnap.exists()) {
    return "Worked!";
  } else {
    return "Email not found - are you sure you paid dues?";
  }
  // } else {
  //   return "Email is not Valid!";
  // }
};

const addWhiteListedUser = async (email: string): Promise<string> => {
  const ref = doc(db, "whitelistedUsers", email);
  let r = generatePassword();
  setDoc(ref, { pwd: r });
  return r;
};

const getUser = async (userId: string) => {
  const docRef = doc(db, "users", userId);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    return { ...docSnap.data(), id: userId };
  } else {
    // doc.data() will be undefined in this case
    console.log("No such document!");
  }
};

const createUser = async (user: UserSignUpModel) => {
  const { firstName, lastName, email } = user;

  const pwd = await addWhiteListedUser(email);

  const ref = collection(db, "users");

  await addDoc(ref, {
    firstName: firstName,
    lastName: lastName,
    email: email,
    amSessionsIds: [],
    pmSessionsIds: [],
    amSessionsNames: [],
    pmSessionsNames: [],
    admin: false,
    password: pwd,
  });

  return pwd;
};

const signIn = async (email: string, password: string) => {
  const ref = collection(db, "users");
  const q = query(ref, where("email", "==", email));

  const querySnapshot = await getDocs(q);
  const doc = querySnapshot.docs;
  if (doc.length > 0 && doc[0].data().password === password) {
    return { message: "Success", payload: { id: doc[0].id, ...doc[0].data() } };
  } else {
    return { message: "Fail", payload: { id: "undefined" } };
  }
};

const getUserSummaries = async () => {
  const q = query(dbTable);
  const querySnapshot = await getDocs(q);
  let users: any[] = [];
  let userPwds: any[] = [];
  let id = 0;
  let pwdId = 0;
  querySnapshot.forEach((doc) => {
    let data = doc.data();
    userPwds.push({
      id: pwdId,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      password: data.password,
    });
    pwdId++;
    if (
      data.amSessionsNames &&
      data.pmSessionsNames &&
      data.amSessionsNames.length > 0 &&
      data.pmSessionsNames.length > 0
    ) {
      id++;
      users.push({
        id: id,
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        amOne: data.amSessionsNames[0],
        amTwo: data.amSessionsNames[1],
        amThree: data.amSessionsNames[2],
        amFour: data.amSessionsNames[3],
        pmOne: data.pmSessionsNames[0],
        pmTwo: data.pmSessionsNames[1],
        pmThree: data.pmSessionsNames[2],
        pmFour: data.pmSessionsNames[3],
      });
    }
  });
  return { users, userPwds };
};

export {
  checkWhiteList,
  createUser,
  getUser,
  addWhiteListedUser,
  getUserSummaries,
  signIn,
};
